import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {TechnicalErrorComponent} from "./technical-error.component";
import {CommonModule} from "@angular/common";

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
    ],
    declarations: [
        TechnicalErrorComponent
    ],
    exports: [
        TechnicalErrorComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})

export class TechnicalErrorModule {

}
